function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#ffcc00",
  d: "M58.74,33.8l-3.18-5.05,1.89-5.67c.26-.77-.06-1.62-.76-2.03l-5.15-2.99-.95-5.91c-.13-.81-.81-1.41-1.62-1.44l-5.94-.23-3.56-4.79c-.49-.65-1.37-.87-2.09-.52l-5.37,2.57-5.37-2.57c-.73-.35-1.61-.13-2.09.52l-3.56,4.79-5.94.23c-.81.03-1.48.63-1.61,1.44l-.95,5.91-5.15,2.99c-.7.41-1.02,1.26-.77,2.03l1.89,5.67-3.18,5.06c-.43.69-.32,1.59.26,2.16l4.29,4.14-.48,5.96c-.06.82.45,1.56,1.22,1.79l5.71,1.66,2.32,5.51c.32.75,1.12,1.18,1.91,1.01l5.82-1.2,4.6,3.79c.31.26.7.39,1.08.39s.76-.13,1.08-.39l4.6-3.79,5.83,1.2c.79.17,1.59-.26,1.91-1.01l2.32-5.51,5.71-1.66c.78-.23,1.29-.97,1.22-1.79l-.48-5.96,4.29-4.14c.58-.57.7-1.47.26-2.16ZM44.31,25.55l-11.92,17.99c-.45.67-1.15,1.12-1.84,1.12s-1.46-.39-1.96-.89l-8.75-8.95c-.6-.61-.6-1.6,0-2.21l2.16-2.21c.6-.6,1.57-.6,2.16,0l5.7,5.83,9.4-14.17c.47-.72,1.43-.9,2.12-.41l2.53,1.75c.7.49.88,1.46.41,2.17Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/editors-badge.0068c7d5.svg";
export { SvgComponent as ReactComponent };